import React from 'react';
import "./Footer.css";

function Footer() {
    return ( 
        <footer>
            <div id="adres">
                <article>
                    Rijksweg Noord 28<br />
                    6111 AP<br />
                    Sint Joost
                </article>
            </div>
            <div id="contact">
                <h3>Bestellen?</h3>
                <h4>U kunt ons bellen op</h4>
                <h2>0475-483769</h2>
            </div>
        </footer>
     );
}

export default Footer;